import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation} from "react-router";
import api from './Services';
import AuthProvider from "./Components/AuthProvider";
import PrivateRoute from "./Components/PrivateRoute";
import Login from "./Components/Login";
import './App.css'
import Navbar from './Components/Navbar'
import Calendar from './Calendar'
import Log from './Log'

export default function App() {
  const [vegetables, setVegetables] = useState({data: [], isLoading:false});

  // Get current URL path (e.g., "/login" or "/dashboard")  
  const location = useLocation();  
 
  // Define routes where navbar should be HIDDEN  
  const noNavbarRoutes = ['/login', '/register'];  
 
  // Show navbar if current path is NOT in noNavbarRoutes  
  const shouldShowNavbar = !noNavbarRoutes.includes(location.pathname);  
 




  // Fetch Vegetable Array


  useEffect(() => {
    const fetchVegetables = async () => {
      setVegetables({...vegetables, isLoading:true})
         api
            .get('/wp-json/wp/v2/vegetable?_fields=id,title&numposts=-1&per_page=99&orderby=title&order=asc')
            .then((response) => {
              //console.log('response.data', response.data)
              setVegetables({data: response.data, isLoading:false})
            })
            .catch((err) => {
              console.log(err.message);
              setVegetables({...vegetables, isLoading:false})
            });          
    }
    fetchVegetables()
 }, []);
  






  return (
    <>
    <div className="min-h-screen bg-purple-900 p-4">
      <div className="max-w-7xl mx-auto">
      <AuthProvider>
      {shouldShowNavbar && <Navbar />}      
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<PrivateRoute />}>
            <Route path="/" element={
              <Calendar 
                vegetables={vegetables.data} 
              />
            } />
            <Route path="/log" element={
              <Log 
                vegetables={vegetables.data} 
              />} 
            />
          </Route>
        </Routes>  
      </AuthProvider>
      </div>
    </div>
    </>
  );
}
